import { createSlice } from "@reduxjs/toolkit";
import { getAllBusinessZoneAction, getBusinessZoneAction, insertUpdateBusinessZoneAction, ChangeStatusBusinessZoneAction } from "../../actions/settingActions/businessZoneAction";
import { toast } from 'react-toastify';

const INITIAL_STATE = {
    allZone: {
        data: {
            records: [],
            totalRecords: 0,
        },
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },

    selectedZone: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },
    firstSelectedZone: {
        data: null,
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
    },

    insertUpdateZone: {
        data: {},

        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    },

    changeStatusZone: {
        data: {},
        apiMsg: {
            message: null,
            status: null,
            type: null,
        },
        newRecord: false
    }

};

const BusinessZoneReducer = createSlice({
    name: "businesscoordinates",
    initialState: INITIAL_STATE,
    reducers: {

        RESET(state, action) {
            state = INITIAL_STATE;
        },
        ResetBusinessZone(state, action) {
            state.allZone = INITIAL_STATE.allZone;
        },
        ResetBusinessZoneSelectState(state, action) {
            state.selectedZone = INITIAL_STATE.selectedZone;
        },
        ResetBusinessFirstZoneSelectState(state, action) {
            state.firstSelectedZone = INITIAL_STATE.firstSelectedZone;
        },
        ResetBusinessZoneDetailsState(state, action) {
            state.selectedZone = INITIAL_STATE.selectedZone;
            state.insertUpdateZone = INITIAL_STATE.insertUpdateZone;
            state.changeStatusZone = INITIAL_STATE.changeStatusZone;
        },
    },
    extraReducers: (builder) => {

        builder.addCase(getAllBusinessZoneAction.fulfilled, (state, action) => {
            // console.log("action.payload.data", action.payload);
            state.allZone.data.records = action.payload.data;
            state.allZone.apiMsg.status = action.meta.requestStatus;
            state.allZone.apiMsg.message = "success";
            // console.log( "state.allZone.data",  state.allZone.data.records);
        });
        builder.addCase(getAllBusinessZoneAction.pending, (state, action) => {
            state.allZone.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(getAllBusinessZoneAction.rejected, (state, action) => {
            state.allZone.apiMsg.message = action.error.message;
            state.allZone.apiMsg.status = action.meta.requestStatus;
        });


        builder.addCase(insertUpdateBusinessZoneAction.fulfilled, (state, action) => {

            const newID = action.payload.data;
            const reqData = action.meta.arg;

            const currentRecords = state.allZone.data.records ? [...state.allZone.data.records] : [];

            if (reqData.businessCoordinatesMasterID) {
                const index = currentRecords.findIndex(
                    r => r.businessCoordinatesMasterID === reqData.businessCoordinatesMasterID
                );

                if (index !== -1) {
                    const newData = {
                        ...currentRecords[index],
                        ...reqData,
                        businessCoordinatesMasterID: newID.data
                    };

                    state.allZone = {
                        ...state.allZone,
                        data: {
                            ...state.allZone.data,
                            records: [
                                ...currentRecords.slice(0, index), newData,
                                ...currentRecords.slice(index + 1),
                            ]
                        }
                    };
                }

            } else {
                const newRecord = {
                    ...reqData,
                    businessCoordinatesMasterID: newID.data,
                };
                state.allZone = {
                    ...state.allZone,
                    data: {
                        ...state.allZone.data,
                        records: [...(state.allZone.data.records || []), newRecord],
                        totalRecords: (state.allZone.data.totalRecords || 0) + 1,
                    },
                };
            }

            state.insertUpdateZone.data = { ...reqData, businessCoordinatesMasterID: newID, ...(reqData.firstTimeZone ? { firstTimeZone: true } : {}) };
            state.insertUpdateZone.apiMsg.status = action.meta.requestStatus;
            state.insertUpdateZone.apiMsg.message = action.payload.message?.message || "Saved Successfully";

            toast.success(state.insertUpdateZone.apiMsg.message, {
                position: "bottom-center",
                toastId: "zone-success",
            });
        });

        builder.addCase(
            insertUpdateBusinessZoneAction.pending,
            (state, action) => {
                state.insertUpdateZone.apiMsg.status = action.meta.requestStatus;
            }
        );
        builder.addCase(
            insertUpdateBusinessZoneAction.rejected,
            (state, action) => {

                state.insertUpdateZone.apiMsg.message = action.error.message;
                state.insertUpdateZone.apiMsg.status = action.meta.requestStatus;

                toast.error(action.error.message ? action.error.message : "Something went wrong please try again", {
                    position: "bottom-center",
                    toastId: "dept-error"
                });
            }
        );


        builder.addCase(getBusinessZoneAction.fulfilled, (state, action) => {
            const reqData = action.meta.arg;

            if (reqData.firstTimeZone === true) {
                state.firstSelectedZone.data = action.payload.data;
                state.firstSelectedZone.apiMsg.status = action.meta.requestStatus;
                state.firstSelectedZone.apiMsg.message = action.payload.message.message;
            } else {
                state.selectedZone.data = action.payload.data;
                state.selectedZone.apiMsg.status = action.meta.requestStatus;
                state.selectedZone.apiMsg.message = action.payload.message.message;
            }

        });

        builder.addCase(getBusinessZoneAction.pending, (state, action) => {
            state.selectedZone.data = null;
            state.selectedZone.apiMsg.message = action.meta.requestStatus;;
            state.selectedZone.apiMsg.status = action.meta.requestStatus;
        });

        builder.addCase(getBusinessZoneAction.rejected, (state, action) => {
            state.selectedZone.apiMsg.message = action.error.message;
            state.selectedZone.apiMsg.status = action.meta.requestStatus;
        });



        builder.addCase(ChangeStatusBusinessZoneAction.fulfilled, (state, action) => {
            if (action.meta.arg) {
                const existingRecords = state.allZone.data.records;
                const roleIdToDelete = action.payload.data.id;

                const updatedRecords = existingRecords.filter(record => record.businessCoordinatesMasterID !== roleIdToDelete);
                state.allZone.data.records = updatedRecords;
            }
            state.changeStatusZone.apiMsg.status = action.meta.requestStatus;
            state.changeStatusZone.apiMsg.message = action.payload.message.message;
        });
        builder.addCase(ChangeStatusBusinessZoneAction.pending, (state, action) => {
            state.changeStatusZone.apiMsg.status = action.meta.requestStatus;
        });
        builder.addCase(ChangeStatusBusinessZoneAction.rejected, (state, action) => {
            state.changeStatusZone.apiMsg.message = action.error.message;
            state.changeStatusZone.apiMsg.status = action.meta.requestStatus;
        });
    }
});

export const { RESET, ResetBusinessZoneDetailsState, ResetBusinessZoneSelectState, ResetBusinessFirstZoneSelectState, ResetBusinessZone } = BusinessZoneReducer.actions;
export default BusinessZoneReducer.reducer;